import React, { Component } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Accordion from 'components/Accordion/Accordion';
import AccordionItem from 'components/Accordion/AccordionItem/AccordionItem';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from '@styles/sidebar.css';

const isReady = element => element.status === 'ready';

const getComponentPagePath = (group, page) => {
  return page.tabs && page.tabs.length
    ? `/${group.path}/${page.path}/${page.tabs[0].path}`
    : '/';
};

const getDocPagePath = page => {
  return page.tabs
    ? `/${page.path}/${page.tabs[0].path}`
    : `/${page.path}`;
};

class Sidebar extends Component {
  static propTypes = {
    componentRoutes: PropTypes.array.isRequired,
    docRoutes: PropTypes.array,
    history: PropTypes.object,
  };

  handleDocLinkClick = page => {
    if(!page.component && !page.tabs) {
      const win = window.open(page.path, '_blank');
      return win.focus();
    }

    this.props.history.push(getDocPagePath(page));
  }

  renderPageLink = (group, page, i) => (
    isReady(page) ?
      <li className="p small" key={`${page.label}-${i}`}>
        <Link to={getComponentPagePath(group, page)}>{page.label}</Link>
      </li> :
      null
  )


  render() {
    const { componentRoutes, docRoutes } = this.props;

    return (
      <aside className={styles.sidebar}>
        <div className={styles.sidebarContainer}>
          <Link to="/" className={styles.iconSection}>
            <div className={styles.airtelLogo}  />
          </Link>

          {
            <Accordion onlyOneOpen>
              {componentRoutes.map((group, i) => (
                <AccordionItem
                  title={group.label}
                  reducedSpaces key={i}
                  disabled={!isReady(group)}
                  className={styles.sidebarPadding}
                >
                  <ul className={styles.linksList}>
                    {group.pages.map((page, i) => this.renderPageLink(group, page, i))}
                  </ul>
                </AccordionItem>
            ))}
            </Accordion>
          }

          <ul className={classnames(styles.docsLinkList, styles.sidebarPadding)}>
            {docRoutes.map((page, i) => (
              <li className="p small" key={`${page.label}-${i}`}>
                <LinkFreeStanding
                  size={'s'}
                  medium
                  onClick={() => this.handleDocLinkClick(page)}
                >
                {page.label}
                </LinkFreeStanding>
              </li>
            ))}
          </ul>
        </div>
      </aside>
    );
  }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar.js